import { FilterItem } from "../filters";

export enum AdminUserRole {
  VIEWER = 1,
  ADMIN = 2,
}

export enum AdminUserStatus {
  ACTIVE = 1,
  INACTIVE = 2,
}

export enum AdminUserSortField {
  CREATED_AT = "createdAt",
  NAME = "name",
  LAST_LOGIN_AT = "lastLoginAt",
}

export const ADMIN_USER_ROLE_OPTIONS: FilterItem[] = [
  { value: String(AdminUserRole.ADMIN), label: "Administrador" },
  { value: String(AdminUserRole.VIEWER), label: "Visualizador" },
];

export const ADMIN_USER_STATUS_OPTIONS: FilterItem[] = [
  { value: String(AdminUserStatus.ACTIVE), label: "Ativo" },
  { value: String(AdminUserStatus.INACTIVE), label: "Inativo" },
];
